import { create } from 'zustand';

const KEY = 'annova.hospital.facility';

function read(): string | null {
  try { return localStorage.getItem(KEY); } catch { return null; }
}

/** The facility the person is working at. The API client sends it with every Health call; the server decides whether it counts. */
export const useFacilityStore = create<{ facilityId: string | null; setFacility: (id: string | null) => void }>((set) => ({
  facilityId: read(),
  setFacility: (facilityId) => {
    try {
      if (facilityId) localStorage.setItem(KEY, facilityId); else localStorage.removeItem(KEY);
    } catch { /* storage unavailable: it lasts for this page */ }
    set({ facilityId });
  },
}));
